import {
  BasicButton,
  BasicInput,
  ModalComponent,
  OptionSelect,
  SelectComponent,
} from "Common/Components";
import { useModalBranch } from "feature/configuration/branch/hooks/useModalBranch";
import { userType, validateUserTypePermited } from "helpers/functionsHelpers";

interface ModalBranchProps {
  isOpen: boolean;
  onHide: () => void;
}

export const ModalBranch = ({ isOpen, onHide }: ModalBranchProps) => {
  const {
    formik,
    municipality,
    departament,
    CompanyData,
    isEdit,
    t,
    valueCompany,
    valueDepartment,
    valueMunicipality,
  } = useModalBranch();

  return (
    <ModalComponent
      modalTitle={isEdit ? t("branch.buttons.edit") : t("branch.buttons.new")}
      onHide={() => {
        onHide();
        formik.resetForm();
      }}
      size="xl"
      show={isOpen}
    >
      <form onSubmit={formik.handleSubmit}>
        <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
          <div className="col-span-12">
            <BasicInput
              label={t("branch.form.labels.description")}
              placeholder={t("branch.form.placeholders.description")}
              id="description"
              type="text"
              value={formik.values.description}
              isError={
                !!(formik.touched.description && formik.errors.description)
              }
              errorMessage={formik.errors.description || ""}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </div>

          <div className="col-span-6">
            <BasicInput
              label={t("branch.form.labels.address")}
              placeholder={t("branch.form.placeholders.address")}
              id="address"
              type="text"
              value={formik.values.address}
              isError={!!(formik.touched.address && formik.errors.address)}
              errorMessage={formik.errors.address || ""}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </div>

          <div className="col-span-6">
            <BasicInput
              label={t("branch.form.labels.phone")}
              placeholder={t("branch.form.placeholders.phone")}
              id="phonenumber"
              type="text"
              value={formik.values.phonenumber}
              isError={
                !!(formik.touched.phonenumber && formik.errors.phonenumber)
              }
              errorMessage={formik.errors.phonenumber || ""}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </div>

          {validateUserTypePermited([userType.adminitrador]) && (
            <div className="col-span-6">
              <SelectComponent
                label={t("branch.form.labels.company")}
                placeholder={t("branch.form.placeholders.company")}
                options={CompanyData || []}
                id="company_id"
                isMulti={false}
                value={valueCompany}
                onChange={(option: OptionSelect) =>
                  formik.setFieldValue("company_id", option.value)
                }
                isError={
                  formik.touched.company_id && Boolean(formik.errors.company_id)
                }
                errorMessage={formik.errors.company_id || ""}
              />
            </div>
          )}

          <div className="col-span-6">
            <SelectComponent
              label={t("branch.form.labels.department")}
              placeholder={t("branch.form.placeholders.department")}
              options={departament || []}
              id="departament_id"
              isMulti={false}
              onBlur={formik.handleBlur}
              value={valueDepartment}
              onChange={(option: OptionSelect) => {
                formik.setFieldValue("departament_id", option.value);
                formik.setFieldValue("municipality_id", "0");
              }}
              isError={
                !!(
                  formik.touched.departament_id && formik.errors.departament_id
                )
              }
              errorMessage={formik.errors.departament_id || ""}
            />
          </div>

          <div className="col-span-6">
            <SelectComponent
              label={t("branch.form.labels.municipality")}
              placeholder={t("branch.form.placeholders.municipality")}
              options={municipality || []}
              id="municipality_id"
              isMulti={false}
              value={valueMunicipality}
              onChange={(option: OptionSelect) =>
                formik.setFieldValue("municipality_id", option.value)
              }
              isError={
                formik.touched.municipality_id &&
                Boolean(formik.errors.municipality_id)
              }
              errorMessage={
                (formik.touched.municipality_id &&
                  formik.errors.municipality_id) ||
                ""
              }
            />
          </div>

          <div className="col-span-12">
            <div className="flex justify-end">
              <BasicButton
                onClick={formik.handleSubmit}
                disabled={formik.isSubmitting}
                type="submit"
              >
                <span className="text-white">
                  {isEdit
                    ? t("branch.buttons.edit")
                    : t("branch.buttons.addbtn")}
                </span>
              </BasicButton>
            </div>
          </div>
        </div>
      </form>
    </ModalComponent>
  );
};
